// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tF6X","field":"styles_field__1hpAI","fieldCol":"styles_fieldCol__QUmZE","diffCol":"styles_diffCol__kYe8l","diff":"styles_diff__2jL0Q"};